// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QUuk7","right":"Footer_right__U_FC5","buttons":"Footer_buttons__1EinF"};